"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedTabContainer = exports.TabsNavigation = exports.TabLink = exports.TabContent = exports.ArrowButton = exports.Wrapper = exports.MainWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _button = _interopRequireDefault(require("../../atoms/button"));

var _fontIcon = _interopRequireDefault(require("../../atoms/font-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: ", ";\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n  box-sizing: border-box;\n  ", " {\n    padding: 0;\n    transition: transform 0.25s ease-in-out;\n  }\n\n  button {\n    box-sizing: border-box;\n    &:focus,\n    &:hover {\n      outline: none;\n      transform: scale(1.1);\n    }\n    transition: transform 0.1s ease-out;\n    > span {\n      box-sizing: border-box;\n      line-height: ", ";\n    }\n    &:first-child {\n      padding-right: 10px;\n    }\n\n    &:last-child {\n      padding-left: 10px;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  width: ", ";\n  ", " {\n    border-bottom: 0;\n    white-space: nowrap;\n    margin-bottom: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  ", ":last-child {\n    margin-right: 0;\n  }\n  transform: ", ";\n  padding: ", ";\n  width: ", ";\n  background: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  line-height: ", ";\n  position: relative;\n  display: inline-block;\n  min-width: 1rem;\n  margin-right: ", ";\n  width: ", ";\n  min-width: ", ";\n\n  text-align: ", ";\n  color: ", ";\n  cursor: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:after {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: '';\n    position: absolute;\n    transform: ", ";\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    border-bottom: 3px solid\n      ", ";\n    pointer-events: none;\n  }\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  var tabColors = (0, _versions.getColor)(props, 'tabs');
  var linkColors = (0, _versions.getColor)(props, 'link');
  return {
    tabColors: tabColors,
    linkColors: linkColors
  };
};

var TabLink = _styledComponents["default"].span(_templateObject(), function (props) {
  return props.height;
}, function (props) {
  return props.autoAlign ? null : props.kind === 'local' ? _tokens.spacing.small : _tokens.spacing.large;
}, function (props) {
  return props.autoAlign ? props.tabWidth : null;
}, function (props) {
  return props.autoAlign ? "".concat(props.minWidth, "rem") : null;
}, function (props) {
  return props.autoAlign ? 'center' : null;
}, function (props) {
  return props.selected ? getColors(props).tabColors.selectedText : getColors(props).tabColors.unselectedText;
}, function (props) {
  return props.selected ? 'default' : 'pointer';
}, function (props) {
  return !props.selected ? getColors(props).linkColors.defaultHover : null;
}, function (props) {
  return props.selected ? 'scaleX(1)' : 'scaleX(0)';
}, function (props) {
  return props.selected ? getColors(props).tabColors.selectedBorder : 'transparent';
});

exports.TabLink = TabLink;

var TabContent = _styledComponents["default"].div(_templateObject2());

exports.TabContent = TabContent;

var TabsNavigation = _styledComponents["default"].div(_templateObject3(), function (props) {
  return getColors(props).tabColors.border;
}, TabLink, function (props) {
  return props.slider && "translate(".concat(props.translateBy, "px)");
}, function (props) {
  return props.background && '0 10px';
}, function (props) {
  return props.slider && "".concat(props.width, "px");
}, function (props) {
  return !props.slider && props.background && getColors(props).tabColors.background;
});

exports.TabsNavigation = TabsNavigation;

var Wrapper = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.width || '90%';
}, TabsNavigation);

exports.Wrapper = Wrapper;

var ArrowButton = function ArrowButton(props) {
  var icon = "icon-".concat(props.type, "-arrow-thin");
  return _react["default"].createElement(_button["default"], _extends({
    view: "plain"
  }, props), _react["default"].createElement(_fontIcon["default"], null, icon));
};

exports.ArrowButton = ArrowButton;

var MainWrapper = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.background && getColors(props).tabColors.background;
}, function (props) {
  return props.background && '0 10px';
}, function (props) {
  return getColors(props).tabColors.border;
}, TabsNavigation, function (props) {
  return props.height;
});

exports.MainWrapper = MainWrapper;

var SelectedTabContainer = _styledComponents["default"].div(_templateObject6(), function (props) {
  return props.kind === 'global' ? _tokens.spacing.large : _tokens.spacing.xxsmall;
});

exports.SelectedTabContainer = SelectedTabContainer;